import React from 'react';
import styled from 'App/styled';

// Adjusted line height from 17 to 16
const Wrapper = styled.div`
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 20px;

  h2 {
    ${({ theme }) => theme.typography.type142};
    color: ${props => props.theme.lightGrey};
    margin-top: 20px;
    margin-bottom: 10px;
  }

  p {
    margin: 0 0 10px;
    color: ${props => props.theme.lightGrey};
    ${({ theme }) => theme.typography.bodySmall};
  }

  a {
    color: ${props => props.theme.brandPrimary};
    text-decoration: none;
  }
`;

interface Props {
  content: string;
}

const ContentForSearch = ({ content }: Props) => {
  if (content) {
    return (
      <Wrapper>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </Wrapper>
    );
  }

  return null;
};

export default ContentForSearch;
